import '../../../core/components/chart-grid/ChartGrid.css';
import './ThresholdIndicators.css';
export var thresholdPlotLine = '_9p8qi20-3-8-0 _13lzg4k0-3-8-0';
export var thresholdPlotRange = '_9p8qi21-3-8-0 _13lzg4k0-3-8-0';